import script from "./EventPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./EventPopup.vue?vue&type=script&setup=true&lang=js"

import "./EventPopup.vue?vue&type=style&index=0&id=6794ebc8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6794ebc8"]])

export default __exports__